<template>
  <div :class="config.template_wrapper_class" v-if="props.config.steps">
    <div class="wpcm-row m-0">
      <slot name="left_sidebar"></slot>
      <div class="wpcm-col col-content" :style="{ backgroundImage: `url(${config.background_image})` }">
        <el-steps
          v-if="showStepIndicator"
          class="wpcm-donation-steps"
          :active="activeStep"
          finish-status="success"
        >
          <el-step
            v-for="(label, idx) in stepLabels"
            :key="idx"
            :title="label"
          />
        </el-steps>
        <slot name="global_top"></slot>
        <div v-for="(step) in props.config.steps" :key="step + randKey">
          <div v-if="step == props.currentStep" :key="step + randKey">
            <div class="wpcm-row">
              <slot :name="`step_${step}_ttop`"></slot>
              <slot :name="`step_${step}_top`"></slot>
              <slot :name="`step_${step}_middle`"></slot>
              <slot :name="`step_${step}_bottom`"></slot>
            </div>
          </div>
        </div>
        <slot name="global_bottom"></slot>
      </div>
      <slot name="right_sidebar"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
const props = defineProps(['config', 'currentStep']);

const randKey = computed(() => {
  return (Math.random() + 1).toString(36).substring(7);
})

const totalSteps = computed(() => {
  const n = Number(props.config?.steps) || 1;
  return n > 0 ? n : 1;
});

const showStepIndicator = computed(() => {
  return !!props.config?.show_step_indicator && totalSteps.value > 1;
});

const stepLabels = computed(() => {
  const titles: string[] = Array.isArray(props.config?.step_titles) ? props.config.step_titles : [];
  const out: string[] = [];
  for (let i = 0; i < totalSteps.value; i++) {
    const t = (titles[i] ?? '').toString().trim();
    out.push(t !== '' ? t : `Step ${i + 1}`);
  }
  return out;
});

const activeStep = computed(() => {
  const current = Number(props.currentStep) || 1;
  return Math.max(0, current - 1);
});
</script>

<style>
.wpcm-donation-steps {
  margin: 0 0 20px;
  padding: 10px 0 0;
}
</style>
